/* ============================================================
   Creazioni Alluminio Gì — shared behaviour
   - Reveal-on-scroll for .gi-reveal elements
   - AJAX add-to-cart for forms marked with [data-gi-ajax-cart]
   - Cart count badge updates via [data-gi-cart-count]
   ============================================================ */
(function () {
  'use strict';

  var routes = window.GIRoutes || {};
  var cartAddUrl = routes.cartAdd || '/cart/add';
  var cartUrl = routes.cart || '/cart';

  /* ---- Reveal on scroll ---- */
  function initReveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('.gi-reveal:not(.is-in)');
    if (!els.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---- Cart count badges ---- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-gi-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', 'hidden');
      }
    });
  }

  function refreshCartCount() {
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      });
  }

  /* ---- AJAX add to cart ----
     Any product form with data-gi-ajax-cart is submitted via fetch.
     Optional attributes on the form:
       data-gi-added-label  — temporary button label after a successful add
     If the request fails for network reasons we fall back to a normal submit. */
  function flashButton(button, label) {
    if (!button) return;
    var original = button.dataset.giOriginalLabel || button.textContent;
    button.dataset.giOriginalLabel = original;
    button.textContent = label;
    button.disabled = true;
    window.setTimeout(function () {
      var form = button.form;
      if (form && form.hasAttribute('data-gi-unavailable')) {
        // The selected variant became unavailable meanwhile: keep the
        // button disabled with the sold-out label set by the section JS.
        button.textContent = form.dataset.giSoldOutLabel || original;
        return;
      }
      button.textContent = original;
      button.disabled = false;
    }, 1600);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-gi-ajax-cart')) return;

    event.preventDefault();

    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    var addedLabel = form.dataset.giAddedLabel || '✓';
    var errorLabel = form.dataset.giErrorLabel || '!';
    var url = cartAddUrl.indexOf('.js') === -1 ? cartAddUrl + '.js' : cartAddUrl;

    if (button) button.setAttribute('aria-busy', 'true');

    fetch(url, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || data.message || 'error');
          });
        }
        return res.json();
      })
      .then(function () {
        flashButton(button, addedLabel);
        return refreshCartCount();
      })
      .catch(function (error) {
        if (error instanceof TypeError) {
          // Network-level failure: let the browser do a full form submit.
          form.removeAttribute('data-gi-ajax-cart');
          form.submit();
          return;
        }
        flashButton(button, errorLabel);
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  });

  /* ---- Boot + theme editor support ---- */
  function init() {
    initReveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
  });

  window.GI = {
    initReveal: initReveal,
    updateCartCount: updateCartCount,
    refreshCartCount: refreshCartCount,
  };
})();
